import React from 'react';
import clsx from 'clsx';
import { ExperimentStatus as ExperimentStatusEnum } from 'apps/experiments/src/types';
import { SvgIconReact, SvgIconType } from 'common/components/svg-icon';
import { useTranslation } from 'common/i18n/hooks';
import styles from './index.module.styl';
type ExperimentStatusProps = {
  status: ExperimentStatusEnum;
  percent?: number;
};
export function ExperimentStatus(_ref: ExperimentStatusProps) {
  let {
    status,
    percent
  }: ExperimentStatusProps = _ref;
  const i18n = useTranslation();
  let label = "";
  let className = "";
  let width = undefined;
  let clipPath = undefined;
  let icon: SvgIconType | undefined = undefined;
  switch (status) {
    case ExperimentStatusEnum.DRAFT:
      label = i18n.t("experiments.status.draft");
      className = styles.draft;
      break;
    case ExperimentStatusEnum.ACTIVE:
      label = i18n.t("experiments.status.active");
      className = styles.active;
      width = "".concat(100 * (percent !== null && percent !== void 0 ? percent : 0), "%");
      clipPath = "inset(0 0 0 ".concat(width, ")");
      break;
    case ExperimentStatusEnum.CONCLUDED:
      label = i18n.t("experiments.status.concluded");
      className = styles.concluded;
      break;
    case ExperimentStatusEnum.SUCCESS:
      label = i18n.t("experiments.status.success");
      className = styles.success;
      icon = "checkmark";
      break;
    case ExperimentStatusEnum.FAIL:
      label = i18n.t("experiments.status.fail");
      className = styles.fail;
      break;
  }
  return <div className={clsx(styles.bar, className)} data-sentry-component="ExperimentStatus" data-sentry-source-file="index.tsx">
      <div className={styles.barInner} style={{
      width
    }} />
      <div className={styles.label}>
        <LabelContent icon={icon} label={label} data-sentry-element="LabelContent" data-sentry-source-file="index.tsx" />
      </div>
      <div className={clsx(styles.label, styles.front)} style={{
      clipPath
    }}>
        <LabelContent icon={icon} label={label} data-sentry-element="LabelContent" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
}
type LabelContentProps = {
  icon?: SvgIconType;
  label: string;
};
function LabelContent(_ref2: LabelContentProps) {
  let {
    icon,
    label
  }: LabelContentProps = _ref2;
  return <>
      {icon && <div className={styles.icon}>
          <SvgIconReact icon={icon} />
        </div>}
      {label}
    </>;
}